import { render } from "./AppMain.vue?vue&type=template&id=7c273c8a&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-7c273c8a"

export default script